import { Box, BoxProps, useStyleConfig } from '@chakra-ui/react';
import { ComponentStyleConfig } from '@chakra-ui/theme';

const CardStyles: ComponentStyleConfig = {
  baseStyle: {
    display: 'flex',
    flex: 1,
    flexDir: 'column',
    bgColor: 'base2Colour.400',
    mb: 1.5,
    alignItems: 'stretch',
    justifyContent: 'space-between',
    pb: 2.5,
  },
};

const Card = ({ children, ...props }: BoxProps) => {
  const styles = useStyleConfig('Card');
  return (
    <Box __css={styles} {...props}>
      {children}
    </Box>
  );
};

export { Card, CardStyles };
